import React from "react";
import "./Style.css";
import Banner from "./Banner";
import Header from "./Header";
import Feature from "../Main/Feature";

export default function About() {
  return (
    <>
      <Banner />
      <Header />
      <Feature />
    </>
  );
}
